"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = FoxIconErrorSolid;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _index = _interopRequireDefault(require("./index"));
var _prepareSvg = require("./prepareSvg");
var id = 'icon-error-solid';
var symbolStr = "<symbol id=\"icon-error-solid\" viewBox=\"0 0 1024 1024\"><path d=\"M42.666667 512C42.666667 252.8 252.8 42.666667 512 42.666667s469.333333 210.133333 469.333333 469.333333-210.133333 469.333333-469.333333 469.333333S42.666667 771.2 42.666667 512z m371.498666-158.165333a42.666667 42.666667 0 0 0-60.330666 60.330666L451.669333 512l-97.834666 97.834667a42.666667 42.666667 0 1 0 60.330666 60.330666L512 572.330667l97.834667 97.834666a42.666667 42.666667 0 0 0 60.330666-60.330666L572.330667 512l97.834666-97.834667a42.666667 42.666667 0 0 0-60.330666-60.330666L512 451.669333 414.165333 353.834667z\"></path></symbol>";
var updated = false;
if (!updated) {
  (0, _prepareSvg.push)(id, symbolStr);
  updated = true;
}
function FoxIconErrorSolid(props) {
  return /*#__PURE__*/_react["default"].createElement(_index["default"], (0, _extends2["default"])({
    type: id
  }, props));
}